<template>
  <v-app-bar
    app
    flat
    dark
    color="primary"
    fixed
    height="64"
    ref="toolbar"
    id="app-toolbar"
  >
    <!-- Replaced v-toolbar-side-icon with v-app-bar-nav-icon -->
    <v-app-bar-nav-icon
      v-if="!stateless"
      @click.stop="drawerToggle"
    ></v-app-bar-nav-icon>

    <div class="admin-toolbar__context min-width-0 ml-1 ml-sm-3">
      <div class="text-subtitle-1 font-weight-bold text-truncate">
        {{ pageTitle }}
      </div>
      <div class="text-caption text-truncate admin-toolbar__subtitle">
        {{ currentOrganization.name }}<span class="hidden-xs-only"> · {{ todayLabel }}</span>
      </div>
    </div>

    <v-spacer />

    <!-- <v-btn icon @click.stop="helpToggle" v-if="!stateless">
      <v-icon>mdi-help-circle</v-icon>
    </v-btn> -->

    <!-- <LaunchTerminal class="px-1" /> -->
    <!-- <TasksButton /> -->
    <ToolbarMenu class="ml-2" />
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ToolbarMenu from "./Menu.vue";
import TasksButton from "../../Tasks/components/Button";
// import LaunchTerminal from "./LaunchTerminal";

export default {
  data() {
    return {
      stateless: false,
    };
  },
  methods: {
    ...mapActions("layout", ["drawerToggle", "helpToggle"]),
  },
  computed: {
    ...mapGetters("global", ["currentOrganization"]),
    pageTitle() {
      if (this.$route && this.$route.meta && this.$route.meta.title) return this.$route.meta.title;
      const name = (this.$route && this.$route.name) || "Dashboard";
      return String(name).replace(/[-_]/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
    },
    todayLabel() {
      return this.$moment().format("MMM D, YYYY");
    },
  },
  components: {
    ToolbarMenu,
    TasksButton,
    // LaunchTerminal,
  },
};
</script>

<style scoped>
.admin-toolbar__context { line-height: 1.25; }
.admin-toolbar__subtitle { opacity: 0.82; }
</style>
